import angular from 'angular';
import coreModule from './core.module';
import vendorModule from './vendor.module';
import accountModule from './account.module';
import loginModule from './login.module';
import bookingModule from './booking.module';
import stockModule from './stock.module';

import reportModule from './report.module';
import clubModule from './club.module';
import directivesModule from './directives.module';
import configModule from './config.module';
import routingModule from './routing/routing.module';
import ReservationRules from './reservation-rules.module';
import PriceModifiers from './price-modifiers.module';
import TurnTypes from './turn-types.module';
import BackofficeDashboard from './backoffice-dashboard.module';
import SportclubWppIntegrationModule from './sportclub-wpp-integration.module';
import WhatsAppDisconnectedReminderModule from './whatsapp-disconnected-reminder.module';
import newMpIntegrationModule from './new.mercadopago.integration.module';
import intercomDashboardModule from './intercom.dashboard.module';
import DaysLeftCounterModule from './days.left.counter.module';
import CashRegisterReconciliationModule from './cash-register-reconciliation.module';

import ModalsReminderModule from './reminders-modals.module';

import paymentsModule from './payments.module';
import sessionSyncModule from './session-sync.module';
import managerInstallationModule from './manager-installation.module';

import AppController from './controllers/app.controller';
import FeedbackController from './controllers/feedback.controller';
import UserinfoController from './controllers/nav.user.controller';

angular
    .module('app', [
        vendorModule,
        coreModule,
        configModule,
        routingModule,
        accountModule,
        loginModule,
        bookingModule,
        reportModule,
        clubModule,
        stockModule,
        paymentsModule,
        directivesModule,
        DaysLeftCounterModule,
        CashRegisterReconciliationModule,
        ModalsReminderModule,
        ReservationRules,
        PriceModifiers,
        TurnTypes,
        BackofficeDashboard,
        SportclubWppIntegrationModule,
        WhatsAppDisconnectedReminderModule,
        newMpIntegrationModule,
        intercomDashboardModule,
        sessionSyncModule,
        managerInstallationModule,
    ])
    .controller('AppController', AppController)
    .controller('FeedbackController', FeedbackController)
    .controller('UserinfoController', UserinfoController);
